import React, { useContext, useState, useEffect } from 'react'

import FullScreenPopup from '@/product/components/organisms/FullScreenPopup'
import {
    currencyFormatWithDecimal,
    dateTimeFormatFunction,
} from '@/product/common/components'
import { Button } from '@mui/material'

const InvoiceView = (props) => {
    const [print, setPrint] = useState(false)

    const data = props.data
    const toggleFullScreenPopup = props.function
    const array = props.array
    let product = array.filter((e) => e.id == data.id)[0]
    return (
        <FullScreenPopup
            modaltitle="VIEW INVOICE"
            open={data.popup}
            handleClose={() => toggleFullScreenPopup(false)}
        >
            <div className="container-lg productInvoice">
                <h3 className="invoiceTitle">Invoice</h3>
                <div className="d-flex justify-content-end align-items-center mb-2 noPrint">
                    {/* <Breadcrumbs aria-label="breadcrumb" className="naBreadcrumbs">
                        <Link to="/dashboard/won">Dashboard</Link>
                        <Typography color="textPrimary">Invoice</Typography>
                    </Breadcrumbs> */}
                    <Button id="invoice_print" onClick={() => window.print()}>
                        <span className="material-icons">print</span>
                        print
                    </Button>
                </div>
                <div
                    className={`invoiceView ${print ? 'invoiceViewPrint' : ''}`}
                    style={{ height: '100%', width: '100%' }}
                >
                    <div className="card-body">
                        <div className="row mb-4">
                            <div className="col-sm-6 invAddr">
                                <h3 className="text-dark mb-1">
                                    {' '}
                                    Title : {product ? product.title : null}
                                </h3>
                                <div>
                                    {' '}
                                    Site ID : {product ? product.site_id : null}
                                </div>
                                <div>
                                    {' '}
                                    Description :{' '}
                                    {product ? product.description : null}
                                </div>
                                <div>
                                    {' '}
                                    Status : {product ? product.paid : null}
                                </div>
                                {product && product.paid == 'PAID' ? (
                                    <div>
                                        Date :{' '}
                                        {product.paid_at
                                            ? dateTimeFormatFunction(
                                                  product.paid_at
                                              )
                                            : '-'}
                                    </div>
                                ) : null}
                            </div>
                        </div>
                        <div className="row mt-5">
                            <div className="col-12">
                                <div className="table-responsive">
                                    <table className="table table-clear nellisInvTot">
                                        <tbody>
                                            {product ? (
                                                <>
                                                    {product.paymentList.length
                                                        ? product.paymentList.map(
                                                              (e) => (
                                                                  <tr>
                                                                      <td
                                                                          className="left"
                                                                          align="right"
                                                                      >
                                                                          <span className="text-dark">
                                                                              {
                                                                                  e.name
                                                                              }
                                                                          </span>
                                                                      </td>
                                                                      <td className="right">
                                                                          <span className="text-dark">
                                                                              {currencyFormatWithDecimal(
                                                                                  e.amount
                                                                              )}
                                                                          </span>
                                                                      </td>
                                                                  </tr>
                                                              )
                                                          )
                                                        : ''}
                                                    <tr>
                                                        <td
                                                            className="left"
                                                            align="right"
                                                        >
                                                            <span className="text-dark">
                                                                Amount
                                                            </span>
                                                        </td>
                                                        <td className="right">
                                                            <span className="text-dark">
                                                                {currencyFormatWithDecimal(
                                                                    product.amount
                                                                )}
                                                            </span>
                                                        </td>
                                                    </tr>
                                                    {product.card_fee_percentage >
                                                    0 ? (
                                                        <>
                                                            <tr>
                                                                <td
                                                                    className="left"
                                                                    align="right"
                                                                >
                                                                    <span className="text-dark">
                                                                        {` Credit Card Fee (${product.card_fee_percentage}%)`}
                                                                    </span>
                                                                </td>
                                                                <td className="right">
                                                                    <span className="text-dark">
                                                                        {currencyFormatWithDecimal(
                                                                            product.card_fee
                                                                        )}
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                        </>
                                                    ) : null}
                                                    {product.tax_percentage >
                                                    0 ? (
                                                        <>
                                                            <tr>
                                                                <td
                                                                    className="left"
                                                                    align="right"
                                                                >
                                                                    <span className="text-dark">
                                                                        {` Total Tax Amount (${product.tax_percentage}%)`}
                                                                    </span>
                                                                </td>
                                                                <td className="right">
                                                                    <span className="text-dark">
                                                                        {currencyFormatWithDecimal(
                                                                            product.tax_amount
                                                                        )}
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                        </>
                                                    ) : null}
                                                    <tr>
                                                        <td
                                                            className="left"
                                                            align="right"
                                                        >
                                                            <span className="text-dark">
                                                                Total Amount
                                                            </span>
                                                        </td>
                                                        <td className="right">
                                                            <span className="text-dark">
                                                                {
                                                                    product.total_amount
                                                                }
                                                            </span>
                                                        </td>
                                                    </tr>
                                                </>
                                            ) : null}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <h4 className="thankText">thank_you_for_shopping_with_us</h4> */}
            </div>
        </FullScreenPopup>
    )
}

export default InvoiceView
